import { DCBaseGamepadAxesEvent } from "./DCBaseGamepadAxesEvent.js";
export class DCGamepadAxesMoveEvent extends DCBaseGamepadAxesEvent {
    eventType = "gamepad-axes-move";
    inputType = "gamepad-axes";
    constructor() {
        super();
    }
}
